<template>
<Navigation>
  <div id="projects">
    <div class="list">
      <div class="project" v-for="(project,id) in projects" :key="id">
        <div class="logo">
          <img :src="project.logo" alt="" width="50" height="50">
        </div>
      </div>
    </div>
  </div>
</Navigation>
</template>

<script>
import Navigation from '@/pages/Navigation.vue';
// import Multiselect from 'vue-multiselect'

export default {
  name: 'Projects',
  components: {
    Navigation,
  },
  data() {
    return {
      projects: [{
          name: "Translator",
          bundleId: "app.voice-translator.ios",
        },
        {
          name: "Gum VPN",
          bundleId: "co.bosger.easyvpn",
        },
        {
          name: "Chamy VPN",
          bundleId: "com.prodinfire.vpn",
        },
      ]
    }
  },
  methods: {}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
<style lang="scss">@import '../assets/variables.scss';

.chart-wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;

  .event-groups {
    margin-top: 20px;
    padding: 10px;
    min-width: 120px;
    width: 15%;

    .event-checkbox {
      display: flex;
      justify-content: space-between;
    }
  }

  .charts {
    width: 85%;
  }
}
</style>
